import { useCallback } from "react";
import { redirect } from "src/utilities/window";

export default function useRedirect(url: string): () => void {
  return useCallback(() => {
    redirect(url);
  }, [url]);
}
